import * as types from './mutation-types'

export const unionGetSharesWith = ({ commit }) => {
  return Vue2.prototype.$api.active().get('/unions?include=shareableUnions')
    .then((response) => {
      commit(types.UNION_GET_SHARES_WITH, response.data)
    })
}

export const organizationGetMembershipTitles = ({ commit }) => {
  return Vue2.prototype.$api.active().get('/unions?include=membershipTitles')
    .then((response) => {
      commit(types.ORGANIZATION_GET_MEMBERSHIP_TITLES, response.data)
    })
}

export const organizationGetAccessRequestFields = ({ commit }) => {
  return Vue2.prototype.$api.active().get(`forms`,{
    params: {
      scope: 'access-request',
    },
  }).then((response) => {
    commit(types.ORGANIZATION_GET_ACCESS_REQUEST_FIELDS, response.data.data)
  })
}